import useSWR, { mutate } from "swr";
import { useMemo } from "react";
import { fetcherPut, fetcher, fetcherPost } from "../utils/axios";

const endpoints = {
    key: '/customer',
    groups: '/groups',
    duplicate: '/duplicate'
}

export async function fetchCustomerGroups(args) {
    const data = await fetcher(args);
    return data?.data;
}

export function useGetCustomerGroups(customerId) {
    const { data, isLoading, error, isValidating, mutate } = useSWR(
        customerId ? `${endpoints.key}/${customerId}${endpoints.groups}` : null,
        fetchCustomerGroups,
        {
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            errorRetryCount: 0
        }
    );
    const memoizedValue = useMemo(() => {
        return {
            groups: data || [],
            isGroupsLoading: isLoading,
            groupsError: error,
            isGroupsValidating: isValidating,
            isGroupsEmpty: !isLoading && !data?.length,
            mutateGroups: mutate
        }
    }, [data, error, isLoading, isValidating]);

    return memoizedValue;
}

export async function addCustomerToGroups(customerId, payload) {
    console.log(typeof payload, 'payload')
    const data = await fetcherPut([endpoints.key + `/${customerId}` + endpoints.groups, payload]);
    mutate(endpoints.key + `/${customerId}` + endpoints.groups);
    return data?.data;
}


export async function duplicateCustomer(customerId, payload) {
    const data = await fetcherPost([endpoints.key + `/${customerId}` + endpoints.duplicate, payload]);
    return data?.data;
}

export async function getCustomerPassword(customerId) {
    const data = await fetcher(`${endpoints.key}/${encodeURIComponent(customerId)}/password`);
    return data?.password;
}
